import React, { useState } from 'react';

interface TeamJerseyProps {
  jerseyUrl?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const TeamJersey: React.FC<TeamJerseyProps> = ({ jerseyUrl, size = 'md', className = '' }) => {
  const [hasError, setHasError] = useState(false);

  const sizeClasses = {
    sm: 'w-[60px] h-[60px]',
    md: 'w-[100px] h-[100px]',
    lg: 'w-[140px] h-[140px]',
  };

  // Don't render anything if no jersey URL is provided or image failed to load
  if (!jerseyUrl || hasError) {
    return null;
  }

  return (
    <img
      src={jerseyUrl}
      alt="Team Jersey"
      className={`${sizeClasses[size]} object-contain ${className}`}
      onError={() => setHasError(true)}
    />
  );
};

export default TeamJersey;
